__turbopack_context__.v({
  "giftcard": "bsYD8G_giftcard",
  "giftcardimage": "bsYD8G_giftcardimage",
  "giftcardtext": "bsYD8G_giftcardtext",
});
